import { faPersonRunning } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Row, Switch, Card } from 'antd'
import React, { useEffect } from 'react'
import MedicalHistoryFormTemplates from '../../utils/templates'
import DesktopMedicalHistoryNav from './Nav'
import useLifestyle from '../../hooks/useLifestyle'
import { LIFESTYLE_SECTIONS } from '../../utils/constants'
import '../style/DesktopLifestyle.css'
import DesktopSectionHeader from './DesktopSectionHeader'

const DesktopLifestyle = ({ setFacet, setSaving }) => {
  const { handleSubmit, handleValueChange, lifestyleData, setLifestyleData } = useLifestyle({
    setFacet,
    setSaving
  })

  // Scroll to top when component mounts
  useEffect(() => {
    setTimeout(() => {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }, 0)
  }, [])

  const renderFormItem = (key, template, section) => {
    switch (template.type) {
      case 'switch':
        return (
          <div className='desktop-lifestyle-switch'>
            <Switch
              checkedChildren={template.checkedChildren}
              unCheckedChildren={template.uncheckedChildren}
              checked={lifestyleData[key]}
              onChange={(value) => handleValueChange(key, value)}
              size='default'
            />
          </div>
        )
      case 'radioGroup':
        return (
          <Row gutter={[16, 16]} className='desktop-lifestyle-options'>
            {template.options.map((opt) => {
              const isChecked = lifestyleData[key] === opt.value

              return (
                <Col xs={24} sm={12} key={opt.value}>
                  <div
                    className={`desktop-lifestyle-option ${isChecked ? 'selected' : ''}`}
                    onClick={() => handleValueChange(key, opt.value)}
                    role='radio'
                    aria-checked={isChecked}
                    tabIndex={0}
                    style={{
                      '--section-color': section.color
                    }}
                  >
                    <div className='desktop-lifestyle-option-icon'>
                      <FontAwesomeIcon icon={section.icon} />
                    </div>
                    <span className='desktop-lifestyle-option-label'>{opt.label}</span>
                  </div>
                </Col>
              )
            })}
          </Row>
        )
      default:
        return null
    }
  }

  const renderSection = (section) => {
    const template = MedicalHistoryFormTemplates.dataModel[section.key]

    if (template.dependency) {
      // eslint-disable-next-line
      const [_, dependencyField] = template.dependency
      if (!lifestyleData[dependencyField]) return null
    }

    const dependentFields = Object.entries(MedicalHistoryFormTemplates.dataModel).filter(
      ([_, fieldTemplate]) => fieldTemplate.dependency && fieldTemplate.dependency[1] === section.key
    )

    return (
      <Card key={section.key} className='desktop-lifestyle-section-card'>
        <div className='desktop-lifestyle-section-header'>
          <div className='desktop-lifestyle-section-icon' style={{ '--section-color': section.color }}>
            <FontAwesomeIcon icon={section.icon} />
          </div>
          <div className='desktop-lifestyle-section-title'>
            <h3>{section.title}</h3>
            <p className='desktop-lifestyle-section-subtitle'>{section.subtitle}</p>
          </div>
        </div>

        <div className='desktop-lifestyle-section-content'>
          {renderFormItem(section.key, template, section)}

          {/* Render dependent fields */}
          {dependentFields.map(([dependentKey, dependentTemplate]) => (
            <div key={dependentKey} className='desktop-lifestyle-dependent-field'>
              <h4 className='desktop-lifestyle-dependent-title'>{dependentTemplate.label}</h4>
              {renderFormItem(dependentKey, dependentTemplate, section)}
            </div>
          ))}
        </div>
      </Card>
    )
  }

  return (
    <div className='desktop-lifestyle-container'>
      <DesktopSectionHeader
        icon={faPersonRunning}
        title='Lifestyle'
        subtitle='Tell us about your daily habits and lifestyle'
      />

      <div className='desktop-lifestyle-content'>
        <Row gutter={[24, 24]}>
          {LIFESTYLE_SECTIONS.map((section) => (
            <Col xs={24} lg={12} key={section.key}>
              {renderSection(section)}
            </Col>
          ))}
        </Row>
      </div>

      <DesktopMedicalHistoryNav
        prevFunction={() => {
          setLifestyleData({
            diet: '',
            physicalActivity: '',
            sleepHours: '',
            waterIntake: '',
            screenTime: '',
            stress: '',
            alcoholConsumption: false,
            alcoholConsumptionLevel: '',
            smoking: false,
            smokingLevel: '',
            smokingYears: '',
            vaping: false,
            vapingLevel: '',
            vapingYears: ''
          })
          setFacet(null)
        }}
        nextFunction={handleSubmit}
        prevText='Back to Overview'
        nextText='Save Lifestyle'
      />
    </div>
  )
}

export default DesktopLifestyle
